var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"id":`app-${_vm.id}`}},[_c('ul',{staticClass:"navbar-nav flex-row flex-lg-column justify-content-between"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }